/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CloudProvidersEnum } from './cloudProvidersEnum';


export interface RansomwareRecoveryDeactivationSpec { 
    vlcr_provider: CloudProvidersEnum;
    /**
     * Cloud Provider Region ID
     */
    vlcr_region: string;
    /**
     * Org id
     */
    vlcr_org_id: string;
    /**
     * Provide approval to delete a ransomware activation in PENDING_DELETION_APPROVAL state.
     */
    approve_deletion?: boolean;
    /**
     * Ignore Failures During API Key Deactivation/Deletion form EDR vendor.
     */
    ignore_api_key_deactivation_failure?: boolean;
    /**
     * Ignore Failures During EDR org deprovision from EDR vendor.
     */
    ignore_edr_org_deprovision_failure?: boolean;
    /**
     * Ignore Failures During IRR Reconfiguration.
     */
    ignore_irr_reconfig_failure?: boolean;
}
export namespace RansomwareRecoveryDeactivationSpec {
}


